import { useMemo } from 'react';
import { ApolloError } from '@apollo/client/errors';
import { ApolloQueryResult } from '@apollo/client';
import {
  CollectorSettingInput,
  CollectorSettingQuery,
  useCollectorSettingQuery
} from 'graphql/types';
export const useCollectorSetting = (
  input: CollectorSettingInput
): {
  data: CollectorSettingQuery | undefined;
  loading: boolean;
  error: ApolloError | undefined;
  refetch: (
    variables?: any
  ) => Promise<ApolloQueryResult<CollectorSettingQuery>>;
} => {
  const result = useCollectorSettingQuery({
    variables: {
      input: input
    },
    fetchPolicy: 'cache-and-network'
  });

  return useMemo(
    () => ({
      loading: result?.loading,
      error: result?.error,
      data: result?.data,
      refetch: result?.refetch
    }),
    [result]
  );
};
